import React from 'react';
import ConfirmMutation from 'mutations/user/confirm';
import ConfirmationForm from 'components/user/authorization/confirmation_form';
import { useError } from 'contexts/error';
import { useParams } from 'react-router-dom';
import { Grid, Stack } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { useMutation } from '@apollo/client/react';
import { CardOptionTypography } from 'components/styles_components/typography';
import { setAuthenticated } from 'utils/authentication';
import { DividerContainer } from 'components/styles_components/container';

const Confirmation = () => {
  const { token } = useParams();
  const setError = useError();

  const [confirmMutation, { loading }] = useMutation(ConfirmMutation, {
    onCompleted: ({ confirmUser }) => {
      setAuthenticated(confirmUser.expiresIn);
    },
    onError: () => {
      setError('error.user.confirm');
    },
  });

  return (
    <Stack>
      <CardOptionTypography variant="h5" align="left">
        <FormattedMessage id="header.user.confirm" />
      </CardOptionTypography>
      <DividerContainer />
      <Grid container direction="row" justifyContent="center" alignItems="center">
        <ConfirmationForm
          initialValues={{ email: '', token }}
          onSubmit={(values) => confirmMutation({ variables: values })}
          processing={loading}
        />
      </Grid>
    </Stack>
  );
};

export default Confirmation;
